import File from './file';
import Import from './import';

export default {
  File,
  Import,
};
